<template>
  <div>
    <div id="container-image">
      <img src="@/assets/mobile_not_support.svg">
    </div>
    <div id="container-text">
      <div>该页面目前不支持移动端展示，</div>
      <div>请移步PC端查看相关页面</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mobile_not_support"
}
</script>

<style>
#container-image {
  width: 100%;
  margin-top: 190px;
  height: auto;
}

#container-image img {
  width: calc(100% - 252px);
  margin: auto;
  display: block;
}

#container-text div {
  font-weight: 500;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
}
</style>
